export enum Action {
  CREATE_SESSION = 'CREATE_SESSION',
  LEAVE_SESSION = 'LEAVE_SESSION',
  JOIN_SESSION = 'JOIN_SESSION',
  CHECKOUT = 'CHECKOUT',
  FIND_ASSIGNED_AGENT = 'FIND_ASSIGNED_AGENT',
  FIND_AGENTS = 'FIND_AGENTS',
  JOIN_AGENT = 'JOIN_AGENT',
  SEND_NOTIFICATION_BROWSER = 'SEND_NOTIFICATION-BROWSER',
  EMIT_SOCKET_EVENT = 'EMIT_SOCKET_EVENT',
  SEND_ONE_SIGNAL_NOTIFICATION = 'SEND_ONE_SIGNAL_NOTIFICATION',
  SEND_ONE_SIGNAL_NOTIFICATION_FORCE_OFFLINE = 'SEND_ONE_SIGNAL_NOTIFICATION-FORCE_OFFLINE',
  DISCONNECT_AGENT = 'DISCONNECT_AGENT',
  AGENT_AVAILABLE_SERVER = 'AGENT_AVAILABLE-SERVER',
  RECEIVING_SOCKET_EVENT = 'RECEIVING_SOCKET_EVENT',
  RECEIVING_NOTIFICATION = 'RECEIVING_NOTIFICATION',
  PRODUCT_LOADING = 'PRODUCT_LOADING',
  PRODUCT_LOADING_FAILED = 'PRODUCT_LOADING_FAILED',
  OPEN_CALL_VIEW = 'OPEN_CALL_VIEW',
  SHOWING_WIDGET_TO_CUSTOMER = 'SHOWING_WIDGET_TO_CUSTOMER',
  SHOWING_CALL_FAILED_SCREEN_TO_CUSTOMER = 'SHOWING_CALL_FAILED_SCREEN_TO_CUSTOMER',
  START_CALL = 'START_CALL',
  END_CALL = 'END_CALL',
  MISSED_CALL = 'MISSED_CALL',
  REJECT_CALL = 'REJECT_CALL',
  CALL_FAILED = 'CALL_FAILED',
  AVAILABLE = 'AVAILABLE',
  CLICK_START_BUTTON = 'CLICK_START_BUTTON',
  CLICK_CLOSE_BUTTON = 'CLICK_CLOSE_BUTTON',
  CLICK_LIVE_CHAT_BUTTON = 'CLICK_LIVE_CHAT_BUTTON',
  WIDGET_CLOSED_BY_CUSTOMER = 'WIDGET_CLOSED_BY_CUSTOMER',
  WIDGET_OPENED_BY_CUSTOMER = 'WIDGET_OPENED_BY_CUSTOMER',
  OFFLINE_LINK_CLICKED_BY_CUSTOMER = 'OFFLINE_LINK_CLICKED_BY_CUSTOMER',
  SHARE = 'SHARE',
  BASKET = 'BASKET',
  CART = 'CART',
  OFFLINE = 'OFFLINE',
  CALL_END_BUTTON_CLICKED = 'CALL_END_BUTTON_CLICKED',
  AGENT_SUBMIT_SURVEY = 'AGENT_SUBMIT_SURVEY',
  CUSTOMER_SUBMIT_SURVEY = 'CUSTOMER_SUBMIT_SURVEY',
  IN_CONFERENCE = 'IN_CONFERENCE',
  CONNECTION_DESTROYED = 'CONNECTION_DESTROYED',
  SESSION_DESTROYED = 'SESSION_DESTROYED',
  ERROR = 'ERROR',
  SELF_SIGNUP = 'SELF_SIGNUP',
  SEND_MOBILE_NOTIFICATION = 'SEND_MOBILE_NOTIFICATION',
  EXPERT_MIC_VOLUME = 'EXPERT_MIC+VOLUME',
  SUBMIT_SURVEY = 'SUBMIT_SURVEY',
  NETWORK_ISSUE = 'NETWORK_ISSUE',
  PERMISSION_REQUESTED = 'PERMISSION_REQUESTED',
  CLOSE_ON_PERMISSION_SCREEN = 'CLOSE_ON_PERMISSION_SCREEN',
  CLOSE_ON_WAITING_SCREEN = 'CLOSE_ON_WAITING_SCREEN',
  CLOSE_ON_LOADING_SCREEN = 'CLOSE_ON_LOADING_SCREEN',
  CLOSE_ON_APPOINTMENT_SCREEN = 'CLOSE_ON_APPOINTMENT_SCREEN',
  CLOSE_ON_ERROR_SCREEN = 'CLOSE_ON_ERROR_SCREEN',
  CLOSE_ON_RETRY_QUEUE_SCREEN = 'CLOSE_ON_RETRY_QUEUE_SCREEN',
  CLOSE_ON_CURRENT_PAGE = 'CLOSE_ON_CURRENT_PAGE'
}
